import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/components/views/Login";
import Home from '@/components/views/Home'
import CardBayi from "@/components/views/CardBayi";
import CustomerList from "../components/views/CustomerList";
import CustomerCreate from "../components/views/CustomerCreate";
import LimitLog from "../components/views/LimitLog";
import Account from "../components/views/Account";
import AccountCasino from "../components/views/AccountCasino";
import CasinoLog from "../components/views/CasinoLog";
import ChangePassword from "../components/views/ChangePassword";
import CustomerDetail from "../components/views/CustomerDetail";
import CustomerUpdate from "../components/views/CustomerUpdate";
import CouponDetail from "../components/views/CouponDetail";
import Sessions from "../components/views/Sessions";
import LimitRequest from "../components/views/LimitRequest";
import LimitRequests from "../components/views/LimitRequests";
import ResellerList from '../components/views/ResellerList'
import ResellerCreate from '../components/views/ResellerCreate'
import AdminCreate from "../components/views/AdminCreate";
import AdminList from "../components/views/AdminList";
import AdminInfo from "../components/AdminInfo";
import AdminUpdate from "../components/views/AdminUpdate";
import AdminGiro from "../components/views/AdminGiro";
import ResellerInfo from "../components/views/ResellerInfo";
import ResellerUpdate from "../components/views/ResellerUpdate";
import Daily from "../components/views/Daily";
import MyAccount from "../components/views/MyAccount";

Vue.use(Router)

var locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');

export default new Router({

    base: (locale.trim().length && locale != "/") ? '/' + locale : '/'+window.defaultLocale+'/',
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                title: 'Ana Sayfa'
            }
        },
        {
            path: '/my-account',
            name: 'MyAccount',
            component: MyAccount,
            meta: {
                title: 'Hesabım'
            }
        },
        {
            path: '/daily',
            name: 'Daily',
            component: Daily,
            meta: {
                title: 'Gunluk Kasa'
            }
        },
        {
            path: '/cardbayi',
            name: 'CardBayi',
            component: CardBayi,
            meta: {
                title: 'Kupon Sorgulama'
            }
        },
        {
            path: '/reseller-create',
            name: 'ResellerCreate',
            component: ResellerCreate,
            meta: {
                title: 'Bayi Oluştur'
            }
        },
        {
            path: '/reseller-update/:id',
            name: 'ResellerUpdate',
            component: ResellerUpdate,
            meta: {
                title: 'Bayi'
            }
        },
        {
            path: '/reseller-info/:id',
            name: 'ResellerInfo',
            component: ResellerInfo,
            meta: {
                title: 'Bayi'
            }
        },
        {
            path: '/reseller-list',
            name: 'ResellerList',
            component: ResellerList,
            meta: {
                title: 'Bayi Listesi'
            }
        },
        {
            path: '/customer-list',
            name: 'CustomerList',
            component: CustomerList,
            meta: {
                title: 'Müşteri Listesi'
            }
        },
        {
            path: '/customer/:id',
            name: 'CustomerDetail',
            component: CustomerDetail,
            meta: {
                title: 'Müşteri Görüntüleme'
            }
        },
        {
            path: '/customer-create',
            name: 'CustomerCreate',
            component: CustomerCreate,
            meta: {
                title: 'Yeni Musteri'
            }
        },
        {
            path: '/reseller-create',
            name: 'ResellerCreate',
            component: ResellerCreate,
            meta: {
                title: 'Yeni Bayi'
            }
        },
        {
            path: '/admin-giro',
            name: 'AdminGiro',
            component: AdminGiro,
            meta: {
                title: 'Ciro',
                label_name: 'Yönetici'
            }
        },
        {
            path: '/admin-create',
            name: 'AdminCreate',
            component: AdminCreate,
            meta: {
                title: 'Yeni Yonetici'
            }
        },
        {
            path: '/admin-list',
            name: 'AdminList',
            component: AdminList,
            meta: {
                title: 'Admin Listesi'
            }
        },
        {
            path: '/admin-info/:id',
            name: 'AdminInfo',
            component: AdminInfo,
            meta: {
                title: 'Admin Detay'
            }
        },
        {
            path: '/admin-update/:id',
            name: 'AdminUpdate',
            component: AdminUpdate,
            meta: {
                title: 'Admin Detay'
            }
        },
        {
            path: '/limit-log',
            name: 'LimitLog',
            component: LimitLog,
            meta: {
                title: 'Limit Arttirma'
            }
        },
        {
            path: '/limit-request',
            name: 'LimitRequest',
            component: LimitRequest,
            meta: {
                title: 'Limit Talep'
            }
        },
        {
            path: '/limit-requests',
            name: 'LimitRequests',
            component: LimitRequests,
            meta: {
                title: 'Limit Talep'
            }
        },
        {
            path: '/account',
            name: 'Account',
            component: Account,
            meta: {
                title: 'Gelir Gider'
            }
        },
        {
            path: '/account-casino',
            name: 'AccountCasino',
            component: AccountCasino,
            meta: {
                title: 'Gelir Gider Casino'
            }
        },
        {
            path: '/casino-log',
            name: 'CasinoLog',
            component: CasinoLog,
            meta: {
                title: 'Casino Logs'
            }
        },
        {
            path: '/change-password',
            name: 'ChangePassword',
            component: ChangePassword,
            meta: {
                title: 'Sistem Ayarlari'
            }
        },
        {
            path: '/sessions',
            name: 'Sessions',
            component: Sessions,
            meta: {
                title: 'Oturumlar'
            }
        },
        {
            path: '/customer-update/:id',
            name: 'CustomerUpdate',
            component: CustomerUpdate,
            meta: {
                title: 'Musteri Duzenleme'
            }
        },
        {
            path: '/coupon-detail/:coupon_id',
            name: 'CouponDetail',
            component: CouponDetail,
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js